/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Nejprodávanější`
};

const da_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Bestsellere`
};

const de_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Bestseller`
};

const en_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Bestsellers`
};

const es_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Más vendidos`
};

const fr_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Top ventes`
};

const hu_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Legkedveltebb`
};

const it_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `I più venduti`
};

const nl_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Bestsellers`
};

const pl_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Bestsellery`
};

const pt_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Mais vendidos`
};

const sv_best_sellers = /** @type {(inputs: {}) => string} */ () => {
	return `Bästsäljare`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const best_sellers = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.best_sellers(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("best_sellers", locale)
	if (locale === "cs") return cs_best_sellers(inputs)
	if (locale === "da") return da_best_sellers(inputs)
	if (locale === "de") return de_best_sellers(inputs)
	if (locale === "en") return en_best_sellers(inputs)
	if (locale === "es") return es_best_sellers(inputs)
	if (locale === "fr") return fr_best_sellers(inputs)
	if (locale === "hu") return hu_best_sellers(inputs)
	if (locale === "it") return it_best_sellers(inputs)
	if (locale === "nl") return nl_best_sellers(inputs)
	if (locale === "pl") return pl_best_sellers(inputs)
	if (locale === "pt") return pt_best_sellers(inputs)
	return sv_best_sellers(inputs)
};